import { render, staticRenderFns } from "./tag-tool.vue?vue&type=template&id=2ca038ed&scoped=true"
import script from "./tag-tool.vue?vue&type=script&setup=true&lang=js"
export * from "./tag-tool.vue?vue&type=script&setup=true&lang=js"
import style0 from "./tag-tool.vue?vue&type=style&index=0&id=2ca038ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca038ed",
  null
  
)

export default component.exports